import { useState } from 'react'
import FormRow, { FormRowProps } from 'components/FormRow'
import ComboBox, { ComboBoxProps } from 'components/ComboBox/comboBox'
import { Provider } from 'graphql'

import useProvidersSearch from '../../hooks/providers-search'

export type ProviderPickerProps = {
  debounceKey?: string,
  label?: string,
  onChange: ( id: number, option?: Provider ) => void,
  selectedProvider?: Provider,
  required?: boolean,
	formRowProps?: Partial<FormRowProps>,
} & Partial<Omit<ComboBoxProps<Provider>, 'onChange'>>

export default function ProviderPicker( { debounceKey, onChange, selectedProvider, label, formRowProps, ...props }: ProviderPickerProps ): JSX.Element {
	const [ searchString, setSearchString ] = useState( '' )
	const { loading, data } = useProvidersSearch( searchString, debounceKey )

	const providers = data?.providers ?? []
	const handleChange = ( provider?: Provider ) => {
		onChange( provider?.id ?? 0, provider )
	}
	return (
		<FormRow label={label ?? 'Provider'} {...formRowProps}>
			<ComboBox
				debounceDelayMs={400}
				setSearchString={setSearchString}
				setSelectedOption={handleChange}
				data={providers as Provider[]}
				selectedOption={selectedProvider}
				getName={( provider: Provider ) => provider.name}
				isLoading={loading}
				{...props}
			/>
		</FormRow>
	)
}
